import React from "react";
import AgencyClientsList from "./AgencyClientList";
import {ClientsContentBase} from "../ClientsContentBase";
import { withTranslation } from 'react-i18next';


class AgencyClientsContentClass extends ClientsContentBase {
    render() {
        return (
            <section className="section-content">
                <div className="section-body h-items">
                    <AgencyClientsList doAgencyClientDelete={this.handleAgencyClientDelete}
                                       clients={this.state.clients}
                                       doClientStatusChange={this.handleAgencyClientStatusChange}
                                       afterSuccessfulAgencyClientSubmit={this.props.afterSuccessfulAgencyClientSubmit}
                                       isSuperAdmin={this.state.isSuperAdmin}
                    />
                </div>
                {this.renderActivationModal()}
            </section>
        )
    }
}

export const AgencyClientsContent = withTranslation()(AgencyClientsContentClass);
